<template>
  <v-container>
    <v-row>
      <v-col :sm="8" :offset-sm="2" :lg="6" :offset-lg="3">
        <div class="text-center text-subtitle-1 font-weight-bold mb-2">{{ $t('label.referrer') }}: {{ currentUser.referred_by_agentcode ? currentUser.referred_by_fname : '-' }}</div>
        <!-- Sub agents table -->
        <v-simple-table dense class="transparent no-borders">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"></th>
                <th class="text-left">
                  <v-icon class="transparent primary--text text--lighten-1 mr-1">mdi-account-outline</v-icon>
                  {{ $t('label.invitedByMe') }}
                </th>
                <th class="text-left">
                  <v-icon class="transparent primary--text text--lighten-1 mr-1">mdi-account-supervisor-outline</v-icon>
                  {{ $t('label.invitedByFriend') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(level, i) in agentLevel" :key="i">
                <td class="text-no-wrap agent-level d-flex flex-row align-center my-1">
                  <AgentIcon :level="level.label.replace('Style', '').trim().toUpperCase()" small />
                  <p class="ml-2">{{ level.label }}</p>
                </td>
                <td class="text-center font-weight-bold">
                  {{ currentAgent.my_direct_team[level.level] }}
                </td>
                <td class="text-center font-weight-bold">
                  {{ currentAgent.my_indirect_team[level.level] }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-divider class="mt-8 mb-2" />
    <!-- Team List wrapper -->
    <v-container class="py-4" :class="$vuetify.breakpoint.smAndUp ? 'px-10' : 'px-2'">
      <div>
        <h4 class="text-subtitle-1 font-weight-bold">{{ $t('label.teamList') }}</h4>
        <div>
          <!-- Filter options -->
          <v-select v-model="invitedBy" :items="inviteeOptions" dense single-line class="transparent filter-dropdown no-input-underline" hide-details @change="fetchTeam">
            <template #append>
              <v-icon small class="transparent">mdi-chevron-down</v-icon>
            </template>
            <template #item="{ item }">
              <div class="filter-dropdown--item">
                {{ item.text }}
              </div>
            </template>
          </v-select>

          <!-- Team list table -->
          <v-simple-table class="transparent team-list" v-if="$vuetify.breakpoint.smAndUp">
            <template v-slot:default>
              <tbody>
                <tr v-for="(agent, i) in members" :key="i" @click="$router.push({ name: $constants.ROUTE_NAME.MEMBER_TRANSACTION_HISTORY, params: { memberId: agent.user_id } })">
                  <td class="text-no-wrap agent-level py-3"><AgentIcon :level="agent.rank.replace('Style', '').trim().toUpperCase()" /></td>
                  <td class="text-center text-no-wrap">{{ agent.total_purchases }} {{ $t('label.purchase') }}</td>
                  <td class="text-start">
                    <p class="text-subtitle-2 font-weight-medium">
                      {{ agent.full_name }}
                    </p>
                    <p class="text-caption">{{ invitedBy === '1' ? $t('label.invitedByMe') : $t('label.invitedByFriend') }}</p>
                  </td>
                  <td>
                    {{
                      agent.last_active.replace('Active in', '') === ' few months ago'
                        ? $t('label.lastActiveFewMonthsAgo')
                        : $t('label.lastActiveDayBy', { duration: agent.last_active.replace('Active in', '') })
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div v-if="!$vuetify.breakpoint.smAndUp">
            <v-card v-for="(member, i) in members" :key="i" class="my-4 white" @click="$router.push({ name: $constants.ROUTE_NAME.MEMBER_TRANSACTION_HISTORY, params: { memberId: member.user_id } })">
              <v-card-text class="pb-1">
                <div class="d-flex flex-row align-center mb-1">
                  <AgentIcon :level="member.rank.replace('Style', '').trim().toUpperCase()" />
                  <div class="ml-4">
                    <p class="text-subtitle-1 font-weight-bold">
                      {{ member.full_name }}
                    </p>
                    <p class="text-caption">{{ invitedBy === '1' ? $t('label.invitedByMe') : $t('label.invitedByFriend') }}</p>
                    <p class="text-no-wrap text-caption primary--text text--darken-1">{{ member.total_purchases }} {{ $t('label.purchase') }}</p>
                  </div>
                </div>
                <p class="text-right text-caption">
                  {{
                    member.last_active.replace('Active in', '') === ' few months ago'
                      ? $t('label.lastActiveFewMonthsAgo')
                      : $t('label.lastActiveDayBy', { duration: member.last_active.replace('Active in', '') })
                  }}
                </p>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { localeHelper } from '@/utils'
import AgentIcon from '../AgentIcon.vue'

export default {
  components: { AgentIcon },
  data() {
    return {
      invitedBy: '1',
      inviteeOptions: [
        { text: localeHelper.getMessage('label.invitedByMe'), value: '1' },
        { text: localeHelper.getMessage('label.invitedByFriend'), value: '2' }
      ],
      agentLevel: [
        { label: localeHelper.getMessage('label.executive'), level: 'agent' },
        { label: localeHelper.getMessage('label.silver'), level: 'silver_agent' },
        { label: localeHelper.getMessage('label.gold'), level: 'gold_agent' },
        { label: localeHelper.getMessage('label.platinum'), level: 'platinum_agent' }
      ],
      members: null
    }
  },
  created() {
    this.fetchTeam()
  },
  computed: {
    ...mapState('agent', ['currentAgent']),
    ...mapState('auth', ['currentUser'])
  },
  methods: {
    ...mapActions('agent', ['getAgentTeam']),
    async fetchTeam() {
      await this.getAgentTeam({ type: this.invitedBy }).then((res) => {
        this.members = res.member
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.agent-level {
  vertical-align: middle;
}

.team-list {
  td {
    vertical-align: middle;
  }
}

::v-deep .no-borders {
  td,
  th {
    border-bottom: unset !important;
  }
}
</style>
